/**
 * AUTO-GENERATED FILE - DO NOT EDIT
 * Generated from: finance.fga
 * Run: pnpm run gen:permissions -- finance
 */

import type { ModulePermissions } from './types';

export const financePermissions = {
  module: 'finance',
  displayName: 'Finance',
  entities: [
    {
      name: 'accountBankDetail',
      displayName: 'Account Bank Detail',
      permissions: [
        { key: 'accountBankDetailRead', action: 'Read', category: 'crud' },
        { key: 'accountBankDetailCreate', action: 'Create', category: 'crud' },
        { key: 'accountBankDetailUpdate', action: 'Update', category: 'crud' },
        { key: 'accountBankDetailDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'bill',
      displayName: 'Bill',
      permissions: [
        { key: 'billRead', action: 'Read', category: 'crud' },
        { key: 'billCreate', action: 'Create', category: 'crud' },
        { key: 'billUpdate', action: 'Update', category: 'crud' },
        { key: 'billDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'checkTemplate',
      displayName: 'Check Template',
      permissions: [
        { key: 'checkTemplateRead', action: 'Read', category: 'crud' },
        { key: 'checkTemplateCreate', action: 'Create', category: 'crud' },
        { key: 'checkTemplateUpdate', action: 'Update', category: 'crud' },
        { key: 'checkTemplateDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'counterparty',
      displayName: 'Counterparty',
      permissions: [
        { key: 'counterpartyRead', action: 'Read', category: 'crud' },
      ],
    },
    {
      name: 'exchangeRate',
      displayName: 'Exchange Rate',
      permissions: [
        { key: 'exchangeRateRead', action: 'Read', category: 'crud' },
        { key: 'exchangeRateCreate', action: 'Create', category: 'crud' },
        { key: 'exchangeRateUpdate', action: 'Update', category: 'crud' },
        { key: 'exchangeRateDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'facilityAtm',
      displayName: 'Facility Atm',
      permissions: [
        { key: 'facilityAtmRead', action: 'Read', category: 'crud' },
        { key: 'facilityAtmCreate', action: 'Create', category: 'crud' },
        { key: 'facilityAtmUpdate', action: 'Update', category: 'crud' },
        { key: 'facilityAtmDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'financialAccount',
      displayName: 'Financial Account',
      permissions: [
        { key: 'financialAccountRead', action: 'Read', category: 'crud' },
        { key: 'financialAccountCreate', action: 'Create', category: 'crud' },
        { key: 'financialAccountUpdate', action: 'Update', category: 'crud' },
        { key: 'financialAccountDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'financialAccountAdjustment',
      displayName: 'Financial Account Adjustment',
      permissions: [
        {
          key: 'financialAccountAdjustmentRead',
          action: 'Read',
          category: 'crud',
        },
        {
          key: 'financialAccountAdjustmentCreate',
          action: 'Create',
          category: 'crud',
        },
        {
          key: 'financialAccountAdjustmentUpdate',
          action: 'Update',
          category: 'crud',
        },
        {
          key: 'financialAccountAdjustmentDelete',
          action: 'Delete',
          category: 'crud',
        },
      ],
    },
    {
      name: 'invoice',
      displayName: 'Invoice',
      permissions: [
        { key: 'invoiceRead', action: 'Read', category: 'crud' },
        { key: 'invoiceCreate', action: 'Create', category: 'crud' },
        { key: 'invoiceUpdate', action: 'Update', category: 'crud' },
        { key: 'invoiceDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'payment',
      displayName: 'Payment',
      permissions: [
        { key: 'paymentRead', action: 'Read', category: 'crud' },
        { key: 'paymentCreate', action: 'Create', category: 'crud' },
        { key: 'paymentUpdate', action: 'Update', category: 'crud' },
        { key: 'paymentDelete', action: 'Delete', category: 'crud' },
        { key: 'paymentExport', action: 'Export', category: 'custom' },
      ],
    },
    {
      name: 'paymentTermConfig',
      displayName: 'Payment Term Config',
      permissions: [
        { key: 'paymentTermConfigRead', action: 'Read', category: 'crud' },
        { key: 'paymentTermConfigCreate', action: 'Create', category: 'crud' },
        { key: 'paymentTermConfigUpdate', action: 'Update', category: 'crud' },
        { key: 'paymentTermConfigDelete', action: 'Delete', category: 'crud' },
      ],
    },
    {
      name: 'positivePayTemplate',
      displayName: 'Positive Pay Template',
      permissions: [
        { key: 'positivePayTemplateRead', action: 'Read', category: 'crud' },
        {
          key: 'positivePayTemplateCreate',
          action: 'Create',
          category: 'crud',
        },
        {
          key: 'positivePayTemplateUpdate',
          action: 'Update',
          category: 'crud',
        },
        {
          key: 'positivePayTemplateDelete',
          action: 'Delete',
          category: 'crud',
        },
      ],
    },
    {
      name: 'voucherTemplate',
      displayName: 'Voucher Template',
      permissions: [
        { key: 'voucherTemplateRead', action: 'Read', category: 'crud' },
        { key: 'voucherTemplateCreate', action: 'Create', category: 'crud' },
        { key: 'voucherTemplateUpdate', action: 'Update', category: 'crud' },
        { key: 'voucherTemplateDelete', action: 'Delete', category: 'crud' },
      ],
    },
  ],
} as const satisfies ModulePermissions;

/**
 * Union type of all permission keys in the Finance module
 */
export type FinancePermissionKey =
  | 'accountBankDetailRead'
  | 'accountBankDetailCreate'
  | 'accountBankDetailUpdate'
  | 'accountBankDetailDelete'
  | 'billRead'
  | 'billCreate'
  | 'billUpdate'
  | 'billDelete'
  | 'checkTemplateRead'
  | 'checkTemplateCreate'
  | 'checkTemplateUpdate'
  | 'checkTemplateDelete'
  | 'counterpartyRead'
  | 'exchangeRateRead'
  | 'exchangeRateCreate'
  | 'exchangeRateUpdate'
  | 'exchangeRateDelete'
  | 'facilityAtmRead'
  | 'facilityAtmCreate'
  | 'facilityAtmUpdate'
  | 'facilityAtmDelete'
  | 'financialAccountRead'
  | 'financialAccountCreate'
  | 'financialAccountUpdate'
  | 'financialAccountDelete'
  | 'financialAccountAdjustmentRead'
  | 'financialAccountAdjustmentCreate'
  | 'financialAccountAdjustmentUpdate'
  | 'financialAccountAdjustmentDelete'
  | 'invoiceRead'
  | 'invoiceCreate'
  | 'invoiceUpdate'
  | 'invoiceDelete'
  | 'paymentRead'
  | 'paymentCreate'
  | 'paymentUpdate'
  | 'paymentDelete'
  | 'paymentExport'
  | 'paymentTermConfigRead'
  | 'paymentTermConfigCreate'
  | 'paymentTermConfigUpdate'
  | 'paymentTermConfigDelete'
  | 'positivePayTemplateRead'
  | 'positivePayTemplateCreate'
  | 'positivePayTemplateUpdate'
  | 'positivePayTemplateDelete'
  | 'voucherTemplateRead'
  | 'voucherTemplateCreate'
  | 'voucherTemplateUpdate'
  | 'voucherTemplateDelete';
